import React from 'react'

type ContextType = {
  isShowFilterSection?: boolean
  setShowFilterSection?: (isShowFilterSection: boolean) => void
  onApply?: (data: any) => void
  onCancel?: () => void
  handleSearch?: () => void
  handleRefresh?: () => void
  handleReset?: () => void
  showFilterInPlace?: boolean
}

export const TableFilterContext = React.createContext<ContextType>({
  isShowFilterSection: false,
  setShowFilterSection: () => {},
  onApply: (data: any) => {},
  onCancel: () => {},
  handleSearch: () => {},
  handleRefresh: () => {},
  handleReset: () => {},
  showFilterInPlace: false,
})
